import Component from '@glimmer/component';
import config from 'frontend/config/environment';
interface FormationPartsTestimoniesComponentArgs {
  testimonyVideo: string;
}

export default class FormationPartsTestimoniesComponent extends Component<FormationPartsTestimoniesComponentArgs> {
  config = config;

  get testimonyVideo() {
    if (!this.args.testimonyVideo) return false;
    return this.getVideoLink(this.args.testimonyVideo);
  }

  private getVideoLink(url: string) {
    if (url.includes('youtube') || url.includes('youtu.be')) {
      return url;
    }
    if (url.includes('vimeo.com')) {
      return url;
    }
    if (url.includes('dailymotion.com')) {
      return url;
    }
    return false;
  }
}
